/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';
import * as FB from './utils/service';
import { FBpagesTable } from './table';

type EmbedType = {
  pages: [],
  state: number,
  loading: boolean,
  login: () => void,
  embed: () => void,
  uninstall: () => void,
};

export const Embed = ({
  pages,
  state,
  loading,
  login,
  embed,
  uninstall
}: EmbedType): React.Element<'div'> => {
  return (
    <div>
      <div
        className="text-center embed-container"
      >

        {state === FB.states.sdk_error &&
          <div data-bind="i18n:$L.sdk_fail" />
        }

        {loading && <div className='csspinner' />}

        {state === FB.states.not_login && !loading &&
          <div style={{ marginTop: '60px' }}>
            <div className="text-center">
              <a
                className="btn btn-pink"
                data-bind="click:login"
                onClick={(e: any) => {
                  e.preventDefault();
                  login();
                }}
              >Add events to facebook page</a>
            </div>
            <p
              style={{
                margin: '40px 40px 80px 40px'
              }}
              data-bind="i18n:$L.connect_facebook_not_permission"
            >
              Oops! We’ll need your permission to install our Sparxo ticketing app on your Facebook page.
            </p>
          </div>
        }

        {!!_.size(pages) &&
          <FBpagesTable data={pages} embed={embed} uninstall={uninstall} />
        }
      </div>
    </div>
  );
};
